import { Button } from "@/components/ui/button";
import { NativeOverlaySheet } from "@/components/native/NativeOverlaySheet";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";
import { Zap } from "lucide-react";

interface AutoBidAdjustedSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  originalAmount: number;
  adjustedAmount: number;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const AutoBidAdjustedSheet = ({
  open,
  onOpenChange,
  originalAmount,
  adjustedAmount,
  onConfirm,
  isLoading = false,
}: AutoBidAdjustedSheetProps) => {
  const { language } = useLanguage();
  const bi = carDetailsLabels(language).biddingInfo;
  const fmt = (n: number) => n.toLocaleString("sv-SE");

  return (
    <NativeOverlaySheet
      open={open}
      onOpenChange={onOpenChange}
      title={bi.autoBidAdjustedTitle}
    >
      <p className="text-sm text-muted-foreground leading-relaxed">
        {bi.autoBidAdjustedDesc
          .replace("{original}", fmt(originalAmount))
          .replace("{adjusted}", fmt(adjustedAmount))}
      </p>
      <div className="mt-4 flex flex-col gap-2">
        <Button
          type="button"
          className="w-full gap-1.5 bg-accent hover:bg-accent/90 text-black"
          onClick={onConfirm}
          disabled={isLoading}
        >
          <Zap className="w-4 h-4" />
          {bi.autoBidAdjustedConfirm.replace(
            "{amount}",
            fmt(adjustedAmount),
          )}
        </Button>
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={() => onOpenChange(false)}
          disabled={isLoading}
        >
          {bi.autoBidAdjustedEdit}
        </Button>
      </div>
    </NativeOverlaySheet>
  );
};
